import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "../../TransactionsDataGrid/renderers";
import { priceToFormat } from "../../../helpers/invoice";

import { GridInvoice } from "../../../types";

import styles from "./SumRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const SumRenderer = ({ data }: Props) => {
  const { sum } = data;

  return (
    <div className={styles.sumBlock}>
      <TwoLineGridCell firstLineData={priceToFormat(sum)} />
    </div>
  );
};

export default SumRenderer;
